<template>
  <div class="h-container">
    <div
      ref="contentModuleContainer"
      class="relative grid overflow-hidden transition-all duration-1000"
      :class="{ '!max-h-[800px]': !isOpen }"
      :style="{ 'max-height': maxHeight }"
    >
      <div class="text col-span-8 mx-auto max-w-[800px] pb-24">
        <slot />
      </div>

      <div
        class="pointer-events-none absolute bottom-0 left-0 flex w-full items-end justify-center bg-gradient-to-t from-background from-50% transition-all"
        :class="isOpen ? 'h-20' : 'h-40'"
      >
        <Button icon-name="arrow-right" class="btn-black btn-rounded pointer-events-auto mb-2 md:px-5 md:py-3 md:text-button-xl" @click="toggle">
          {{ isOpen ? t['w.global.read_less']() : t['w.global.read_more']() }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from '~/components/button/Button.vue'
import * as t from '~/messages'

const route = useRoute()

const contentModuleContainer = useTemplateRef('contentModuleContainer')
const isOpen = ref(true)
const maxHeight = ref('max-content')

const updateMaxHeight = () => {
  const contentEl = contentModuleContainer.value
  if (contentEl) {
    maxHeight.value = `${contentEl.scrollHeight}px`
  }
}

const linkClicked = () => {
  if (!isOpen.value) {
    maxHeight.value = 'max-content'
    isOpen.value = true
  }
}

const toggle = async () => {
  if (isOpen.value) {
    // Ensure current value is settled in DOM (if it was just set to 'max-content')
    await nextTick()
    // Update to numeric value in case it is currently set to 'max-content'
    updateMaxHeight()
    // Wait for update to take effect before triggering transition
    await nextTick()
  }

  isOpen.value = !isOpen.value
}

provide('dynamic-node', {
  linkClicked,
})

onMounted(() => {
  if (!route.hash || route.hash === '#') {
    isOpen.value = false
  }

  updateMaxHeight()
})
</script>
